'use client';

import { useMemo } from 'react';

//* Components
import Page from '@/components/global/Page';
import Text from '@/components/global/Text';
import Editor from '@/components/global/Editor';
import Container from '@/components/global/Container';

//* Style
import ImprintStyle from '@/styles/pages/ImprintStyle';

const ImprintTemplate = ({
	pageData: {
		data: { title, items },
	},
}) => {
	//! Items
	const storeItems = useMemo(() => {
		return items.map((item, index) => (
			<div
				key={index}
				className='content-block'>
				<Text className='h5 primary-color1 workSans-medium block-title'>{item.title}</Text>

				<Editor
					data={item.description}
					className='second-version'
				/>
			</div>
		));
	}, [items]);

	return (
		<Page className='imprint'>
			<ImprintStyle>
				<Container row>
					<div className='col-2 col-ds-2 col-dxs-2 col-ts-12' />

					<div className='col-8 col-ds-9 col-dxs-8 col-ts-12'>
						<Text className={'h1 primary-color1 workSans-regular uppercase title'}>{title}</Text>

						<div className='items-wrap'>{storeItems}</div>
					</div>

					<div className='col-2 col-ds-1 col-dxs-2 col-ts-12' />
				</Container>
			</ImprintStyle>
		</Page>
	);
};

export default ImprintTemplate;
